import { defineComponent as d, openBlock as a, createElementBlock as o, mergeProps as i, unref as e, renderSlot as p, createElementVNode as n, createCommentVNode as h } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const u = { key: 0 }, v = { key: 1 }, g = { key: 2 }, A = { key: 3 }, Z = { key: 4 }, f = { key: 5 }, k = {
  name: "ScalarIconAlignCenterHorizontalSimple"
}, M = /* @__PURE__ */ d({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(V) {
    const r = V, { bind: s, weight: l } = m(r);
    return (H, t) => (a(), o("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(s)), [
      p(H.$slots, "default"),
      e(l) === "bold" ? (a(), o("g", u, t[0] || (t[0] = [
        n("path", { d: "M208,76H140V48a12,12,0,0,0-24,0V76H48A20,20,0,0,0,28,96v64a20,20,0,0,0,20,20h68v28a12,12,0,0,0,24,0V180h68a20,20,0,0,0,20-20V96A20,20,0,0,0,208,76Zm-4,80H52V100H204Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (a(), o("g", v, t[1] || (t[1] = [
        n("path", {
          d: "M216,96v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H208A8,8,0,0,1,216,96Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M208,80H136V48a8,8,0,0,0-16,0V80H48A16,16,0,0,0,32,96v64a16,16,0,0,0,16,16h72v32a8,8,0,0,0,16,0V176h72a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Zm0,80H48V96H208v64Z" }, null, -1)
      ]))) : e(l) === "fill" ? (a(), o("g", g, t[2] || (t[2] = [
        n("path", { d: "M224,96v64a16,16,0,0,1-16,16H136v32a8,8,0,0,1-16,0V176H48a16,16,0,0,1-16-16V96A16,16,0,0,1,48,80h72V48a8,8,0,0,1,16,0V80h72A16,16,0,0,1,224,96Z" }, null, -1)
      ]))) : e(l) === "light" ? (a(), o("g", A, t[3] || (t[3] = [
        n("path", { d: "M208,82H134V48a6,6,0,0,0-12,0V82H48A14,14,0,0,0,34,96v64a14,14,0,0,0,14,14h74v34a6,6,0,0,0,12,0V174h74a14,14,0,0,0,14-14V96A14,14,0,0,0,208,82Zm2,78a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V96a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2Z" }, null, -1)
      ]))) : e(l) === "regular" ? (a(), o("g", Z, t[4] || (t[4] = [
        n("path", { d: "M208,80H136V48a8,8,0,0,0-16,0V80H48A16,16,0,0,0,32,96v64a16,16,0,0,0,16,16h72v32a8,8,0,0,0,16,0V176h72a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Zm0,80H48V96H208v64Z" }, null, -1)
      ]))) : e(l) === "thin" ? (a(), o("g", f, t[5] || (t[5] = [
        n("path", { d: "M208,84H132V48a4,4,0,0,0-8,0V84H48A12,12,0,0,0,36,96v64a12,12,0,0,0,12,12h76v36a4,4,0,0,0,8,0V172h76a12,12,0,0,0,12-12V96A12,12,0,0,0,208,84Zm4,76a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V96a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4Z" }, null, -1)
      ]))) : h("", !0)
    ], 16));
  }
});
export {
  M as default
};
